// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__PoQL9","content":"Welcome_content__-QYVa"};